import React, { useEffect, useRef, useState } from "react";
import { alpha3ToAlpha2 } from "@utils/countryCodeMap";
import "./index.sass";

const CountrySelect = ({
  countries,
  value,
  onChange,
  locale,
  placeholder = "Select country",
  error = false,

  // Тимчасово додали можливість блокувати селект.
  // Зараз за вимогами показуємо лише Україну,
  // але сам компонент не видаляємо, щоб потім
  // легко повернути повну логіку вибору країн.
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const selectRef = useRef(null);

  const normalizeAlpha2 = (code) => {
    if (!code || typeof code !== "string") return "";

    return code.trim().toLowerCase();
  };

  const selected = countries.find((country) => {
    if (country.code === value) return true;

    const alpha2FromCountry = alpha3ToAlpha2[country.code];

    return normalizeAlpha2(alpha2FromCountry) === normalizeAlpha2(value);
  });

  const getCountryLabel = (country) =>
    locale === "ru" ? country.label_ru : country.label_en;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!selectRef.current || selectRef.current.contains(event.target)) {
        return;
      }

      setOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="country-select" ref={selectRef}>
      <button
        type="button"
        disabled={disabled}
        className={`country-select__control ${
          !selected ? "is-placeholder" : ""
        } ${error ? "error" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={() => {
          if (disabled) return;

          setOpen((prev) => !prev);
        }}
      >
        <div className="country-select__content">
          <span className="country-select__label">
            {selected ? getCountryLabel(selected) : placeholder}
          </span>
        </div>

        <span className="country-select__arrow">
          {open ? (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M2.83348 9.9999C2.83348 10.1279 2.88213 10.2559 2.98013 10.3533C3.17546 10.5486 3.49215 10.5486 3.68748 10.3533L8.0008 6.03994L12.3141 10.3533C12.5094 10.5486 12.8261 10.5486 13.0215 10.3533C13.2168 10.1579 13.2168 9.84123 13.0215 9.6459L8.3548 4.97923C8.15947 4.7839 7.84278 4.7839 7.64744 4.97923L2.98078 9.6459C2.88211 9.7439 2.83348 9.8719 2.83348 9.9999Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M2.83348 6.00004C2.83348 5.87204 2.88213 5.74402 2.98013 5.64668C3.17546 5.45135 3.49215 5.45135 3.68748 5.64668L8.0008 9.96L12.3141 5.64668C12.5094 5.45135 12.8261 5.45135 13.0215 5.64668C13.2168 5.84202 13.2168 6.15871 13.0215 6.35404L8.3548 11.0207C8.15947 11.216 7.84278 11.216 7.64744 11.0207L2.98078 6.35404C2.88211 6.25604 2.83348 6.12804 2.83348 6.00004Z"
                fill="white"
              />
            </svg>
          )}
        </span>
      </button>

      {/* 
        Тимчасово не показуємо список країн,
        якщо селект заблокований.
        Після повернення функціоналу достатньо
        прибрати disabled у батьківському компоненті.
      */}
      {open && !disabled && (
        <div className="country-select__dropdown">
          {countries.map((country) => (
            <button
              key={country.code}
              type="button"
              className="country-select__option"
              onClick={() => {
                onChange(country.code);
                setOpen(false);
              }}
            >
              {getCountryLabel(country)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelect;